import { render, staticRenderFns } from "./PedidosLista.vue?vue&type=template&id=518d7f58&"
import script from "./PedidosLista.vue?vue&type=script&lang=js&"
export * from "./PedidosLista.vue?vue&type=script&lang=js&"
import style0 from "./PedidosLista.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PedidosLista.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports